import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 30, 
        paddingTop: 0, 
        color: '#fff'
    },
    title: {
        color: '#fff',
    },
    wrap: {
        display: 'flex', 
        flexDirection: 'column',
        width: '100%'
    },
    wrapLabelBlock: {
        position: 'relative', 
        border: '1px solid #fa00ff', 
        color: '#fa00ff', 
        display: 'inline', 
        paddingTop: 15, 
        paddingBottom: 15,
    },
    wrapFirstRow: {
        width: '100%', 
        display: 'flex', 
        justifyContent: 'space-between', 
        minHeight: 240, 
        height: 240, 
        marginBottom: 20
    },
    wrapTwoRow: {
        width: '100%', 
        display: 'flex', 
        justifyContent: 'space-between', 
        minHeight: 220, 
        height: 220, 
        marginBottom: 20
    },
    rootBlock: {
        height: 160, 
        width: '100%',
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center'
    },
    wrapBlock: {
        position: 'relative', 
        display: 'inline', 
        paddingTop: 15, 
        paddingBottom: 15,
    },
    mr12: {
        marginRight: 12
    },
    spin: {
        border: '1px solid #ffce01', 
        color: '#ffce01'
    },
    all: {
        border: '1px solid #0193ff', 
        color: '#0193ff', 
    },
    users: {
        border: '1px solid #fa00ff', 
        color: '#fa00ff',
    },
    labelBlock: {
        position: 'absolute', 
        top: 0, 
        left: 5, 
        fontSize: 12, 
        padding: 0, 
        margin: 0, 
        userSelect: 'none'
    },
    countBlock: {
        fontWeight: 700, 
        paddingLeft: '50px', 
        paddingRight: 50, 
        userSelect: 'none'
    },
    fs30: {
        fontSize: 30,
    },
    fs20: {
        fontSize: 20
    }
}));

export {
    useStyles
}